import { render, staticRenderFns } from "./ui-button.vue?vue&type=template&id=929873f2&"
import script from "./ui-button.vue?vue&type=script&lang=ts&"
export * from "./ui-button.vue?vue&type=script&lang=ts&"
import style0 from "./ui-button.vue?vue&type=style&index=0&id=929873f2&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports